<template>
  <div class="page map">
    <pageTitle title='地图与周边'  v-if=" $route.query.sourceflag != 'app' "  />
    <div id="newmap" v-bind:style="{ height: mapHeight + 'px' }"></div>
        <div class="main" v-bind:style="{ top: top }">
            <div v-if='listState' style='position:relative'>
                <mu-tabs :value="activeTab" @change="handleTabChange" style="background-color:#F9F9F9;position:absolute;top:0px;" >
                    <mu-tab @click="handleTabChange('tab1')" titleClass="tab" value="tab1" title="交通"/>
                    <mu-tab titleClass="tab" value="tab2" title="生活"/>
                    <mu-tab titleClass="tab" value="tab3" title="景点"/>
                    <mu-tab titleClass="tab" value="tab4" title="商圈"/>
                    <mu-tab titleClass="tab" value="tab5" title="其他"/>
                </mu-tabs>
                <div style='overflow-x:hidden;min-height:3.2rem;top:48px;position:relative;' v-bind:style="{ height: height}">
                    <div v-if="activeTab === 'tab'+i" v-for="i in 5">
                        <div v-if="aroundLoad[i-1] == false" style="text-align:center;padding:1rem 0 5rem 0;">
                        <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ;" />
                        </div>
                        <mu-paper>
                            <div class="item" v-for="item in list[i-1]" @click='showDetail(item)'>
                                <div class="left">
                                <div class="img">
                                    <img src="/static/search/demo.jpg"/>
                                </div>
                                    <div class="msg">
                                        <label>{{item.MerchantName}}</label><br/>
                                        <small>离酒店行驶距离{{item.Distance}}公里</small>
                                    </div>
                                </div>                
                                <div class="right">
                                    <a @click.stop="navigation(item.BDLng,item.BDLat)"><img src="/static/search/nav.png"/><br/>导航</a>
                                </div>
                            </div>
                        </mu-paper>
                    </div>
                </div>
            </div>
            <div v-else style="margin:0px;padding:0px;background-color:white;padding-bottom:30px;overflow-y:scroll;overflow-x:hidden;transition: 1.6s;">
                <div style="max-width: 376px; ">
                    <mu-bottom-nav>
                        <div style="width:50%" @click="toggle">
                            <mu-bottom-nav-item style="width:100%" value="nav1" :title="deploy == false?'展开':'收起'" icon="dehaze"/>
                        </div>
                        <div style="width:50%" @click="closeNav">
                            <mu-bottom-nav-item style="width:100%" value="nav2" title="关闭" icon="cancel"/>
                        </div>
                    </mu-bottom-nav>
                    <mu-divider/>
                    <div id="msg" style="padding:2.5em;overflow:auto;" v-bind:style="{ height: height}">
                    </div>
                </div>
            </div>
            <div @click="toggle" class='fixBottom' v-if='showCtr'>        
                <span v-if="deploy"><img style='height:29px' src="../../../static/search/close.png"/></span>
                <span v-if="!deploy"><img style='height:29px' src="../../../static/search/open.png"/></span>
            </div>
        </div>
  </div>
</template>

<style scoepd>
  #newmap{
    width: 7.5rem;
    margin:0;
    font-family:"微软雅黑";
  }
  #msg{
      color:black;
      font-size:0.3rem;
      position:relative;
      margin-top:0px;
  }
</style>

<style lang="less" scoepd>
@import "../../assets/theme.less";
.fixBottom{
    width:100%;
    position:fixed;
    padding:5px;
    bottom:0;
    background-color:#F1F1F1;
    text-align:center;
    display:flex;
    .mu-icon{
        position:relative;
        top:6px;
    }
    span{
        margin:auto;
        display:flex;
        img{
            margin:auto;
        }
    }
}
.item{
    width:7.5rem;
    display:flex;
    display: -webkit-flex;
    padding:15px 0;
    border-bottom:1px solid #F1F1F1;
    overflow:hidden;
    .left{
        width:6rem;
        display:inline-block;
        margin:auto 0.3em;
        label{
            font-size:0.28rem;
            color:@primaryBlack;
        }
        label:hover{
            color:#27BA69;
        }
        small{
            color:@textColor;
            font-size:0.2rem;
        }
        .img{
            width:1.5rem;
            display:inline-block;
            margin:auto;
            img{
                width:100%;
            }
        }
        .msg{
            position:relative;
            top:-0.5rem;
            width:4rem;
            display:inline-block;
            margin:auto 0.2rem;
        }
    }
    .right{
        width:1.1rem;
        display:inline-block;
        margin:auto 0;
        a{
            display:block;
            width:1.5rem;
            text-align:center;
            color:@secondBlack;
            border:none;
            font-size:0.28rem;
            img{
                width:15px;
            }
        }
        a:hover{
            border:none;
        }
    }
}
.item:hover{
    background-color:#F2F2F2;
}
</style>
<style lang="less">
@import "../../assets/theme.less";
.map{
    height:100%;
    overflow:hidden;
    .mu-paper{
        padding-top:0px;
        transition: 0.8s;
        .loading{
            padding-bottom:40px;
        }
    }
    >.main{
      width:7.5rem;
      background-color:white;
      position:fixed;
      bottom:0;
      -webkit-transition:0.6s;
      transition:0.6s;
    }
    .mu-tab-link{
        padding:0px;
    }
    .tab{
        color:@secondBlack;
        font-size:0.28rem;
        font-weight:500;
        margin:0px;
        padding:0px;
        width:1.5rem;
        border-right:1px solid #F1F1F1;
    }
    .mu-tab-link-highlight{
        display:none;
    }
    .mu-tab-active{
        .tab{
            color:#27BA69;
        }
    }
}
</style>


<script>
import {BaiDuMap} from '../../components/BaiDuMap.js'
import Map from '../../components/map.js'
import api from '../../api'
import { mapGetters , mapMutations } from 'vuex'
window.onload = Map.load; 
export default {
  data () {
    return {
      activeTab: '',
      loadState:false,
      loadMsg:'上拉加载更多',
      //是否展开至顶部
      deploy:false,
      list:['','','','',''],
      map:'',
      myIcon:'',
      state:'hidden',
      //坐标是否改变
      change:false,
      driving:'',
      //记录当前覆盖物
      current:'',
      //列表显示状态，和导航状态相反
      listState:true,
      //驾车路由
      route:[],
      //周边是否加载
      aroundState:[],
      //周边加载状态
      aroundLoad:[],
      top: '11rem',
      height:'3.2rem',
      showCtr:false,
      mapHeight:600
    }
  },
  mounted() {

    if(typeof(BMap) != "undefined"){
      this.create();
    }
    else{
      BaiDuMap().then( BMap => {
        // 创建Map实例
        this.create();
      })
    }
  },
  destroyed(){
      Map.load();
  }
  ,
  methods: {
    ...mapMutations({
      setG_currentInfo: 'setG_currentInfo', setG_searchParam: 'setG_searchParam',
      setG_currentRoom: 'setG_currentRoom', setDiscount: 'setG_currentDiscount'
    }),

    //状态初始化
    initState(){
      this.aroundState = [false,false,false,false,false]
      this.aroundLoad = [false,false,false,false,false]
      this.top = '11rem'
      this.list = ['','','','','']
      //展示列表
      this.listState = true
      //地图状态坐标未修改
      this.change = false
    },
    //导航
    navigation(xPos,yPos){
        //移除当前(上一个)覆盖物
        this.map.removeOverlay(this.current)
        //移除上一个导航记录
        this.driving.clearResults();
        var p1 = new BMap.Point(this.g_currentInfo.BmapPoint.split(",")[1],this.g_currentInfo.BmapPoint.split(",")[0]);
        var p2 = new BMap.Point(xPos,yPos)
        this.driving.search(p1, p2);
        if(this.deploy == true){
            this.toggle()
        }
        this.listState = false;
    },
    //展示详情
    showDetail(item){
        this.driving.clearResults();
    	var point = new BMap.Point(item.BDLng,item.BDLat);
        //移除当前(上一个)覆盖物
        this.map.removeOverlay(this.current)
        var marker = new BMap.Marker(point);  // 创建标注
        //记录当前覆盖物
        this.current = marker
        this.map.addOverlay(marker);              // 将标注添加到地图中
        this.map.centerAndZoom(point, 15);
        var opts = {
            width : 200,     // 信息窗口宽度
            height: 40,     // 信息窗口高度
            title : item.MerchantName
        }
        var address = item.MerchantAddress==null?'暂无信息':item.MerchantAddress;
        var infoWindow = new BMap.InfoWindow('地址：'+ address, opts);  // 创建信息窗口对象 
        //marker.addEventListener("click", function(){          
            this.map.openInfoWindow(infoWindow,point); //开启信息窗口
        //});
        if(this.deploy == true){
            this.toggle()
        }
    },
    create(){
        //初始化状态
        this.initState()

        // 尝试获取外挂的参数
        if ( this.$route.query.hotelcode != undefined ){
            var model = this.g_currentInfo;
            model.HotelCode = this.$route.query.hotelcode ;
            this.setG_currentInfo(model);
            this.gethoteldetal();
        }
        else{
            //初始化地图
            this.createMap()
            //获取第一个列表
            this.activeTab = 'tab1'
            this.getList(1)
            this.aroundState[0] = true
        }




    },

    gethoteldetal(){
      console.log(this.g_currentInfo.HotelCode)
      var params = new this.URLSearchParam();
      params.append('hotelCode', this.g_currentInfo.HotelCode);
    //   params.append('startDate', this.g_searchParam.startDate);
    //   params.append('endDate', this.g_searchParam.endDate);
      this.$http.post(api.getHotelDetail(),params.toParam()).then((res) => {
        if(res.Result){
          this.setG_currentInfo(res.Data);

        //初始化地图
        this.createMap()
        }
      })
    },



    handleTabChange (val) {
        if(this.top == '11rem'){
            this.top = '8rem'
        }
        this.showCtr = true
        this.activeTab = val
        var type = val.substring(3,4)
        if(type > 0 && this.aroundState[type-1] == false){
            this.aroundState[type - 1] = true
            this.getList(type)
        }
    },
    //关闭导航明细
    closeNav(){
        //如果列表展开了要关闭
        if(this.deploy == true){
            this.toggle();
        }
        this.listState = true;
    },
    createMap(){
        this.map = new BMap.Map("newmap",{Zoom:15});   
        console.log("test001")
        console.log(this.g_currentInfo.BmapPoint)

        // var point = new BMap.Point(this.g_currentInfo.BmapPoint.split(",")[1],this.g_currentInfo.BmapPoint.split(",")[0]); // 创建点坐标
        // console.log(typeof(this.g_currentInfo.BmapPoint))
        // console.log("gxx")
        // console.log(typeof(point))

        var point = new Object();

        if(this.g_currentInfo.BmapPoint == undefined)
            point = 31.413689,121.353012;
        else
            point = new BMap.Point(this.g_currentInfo.BmapPoint.split(",")[1],this.g_currentInfo.BmapPoint.split(",")[0]); // 创建点坐标


        this.myIcon = new BMap.Icon("../../../static/search/greenTree.png", new BMap.Size(60,44));
        var marker = new BMap.Marker(point,{icon:this.myIcon});  // 创建标注  

        this.map.centerAndZoom(point,15);

        this.map.enableScrollWheelZoom();

        this.map.addOverlay(marker);

        var options = {
            onSearchComplete: function(results){
                if (driving.getStatus() == BMAP_STATUS_SUCCESS){
                    // 获取第一条方案
                    var plan = results.getPlan(0);
                    // 获取方案的驾车线路
                    var route = plan.getRoute(0);
                    // 获取每个关键步骤,并输出到页面
                    var s = [];
                    for(var j = 0;j < plan.getNumRoutes(); j++){
                        var route = plan.getRoute(j);
                        for (var i = 0; i < route.getNumSteps(); i++){
                            var step = route.getStep(i);
                            s.push((i + 1) + ". " + step.getDescription());
                        }
                    }
                    document.getElementById("msg").innerHTML = s.join("<br/>");
                }
            },
            renderOptions:{map: this.map, autoViewport: true}
        };
        var driving = new BMap.DrivingRoute(this.map, options);
        this.driving = driving;
    },
    load(){
        return Map.load;
    },
    toggle(){
        if(this.deploy == false){
          this.top = '56px'
          this.height = '10rem'
          window.scrollTo(0,0);
        }
        else{
          this.height = '3.2rem'
          this.top = '8rem'
          window.scrollTo(0,0);
        }
        this.deploy = !this.deploy;
    },
    getList(type){
        var params = new this.URLSearchParam();
        params.append('type', type-1);
        params.append('hotelCode', this.g_currentInfo.HotelCode);
        params.append('mapLng', this.g_currentInfo.BmapPoint.split(",")[1]);
        params.append('mapLat', this.g_currentInfo.BmapPoint.split(",")[0]);
        this.$http.post(api.getHotelSurround(),params.toParam()).then((res) => {
            if(res.Result){
                this.list.splice(type-1, 1, res.Data)
                this.aroundLoad[type-1] = true
            }
        });
    },

    goback(){
      javascript: history.go(-1);
    },

    },
    computed: {
        ...mapGetters([
        'g_currentInfo'
        ]),
    },
    watch:{ 
        g_currentInfo: {
            handler: function (val, oldVal) {
                this.list = [];
                this.activeTab = '';
                if(val.BmapPoint!= oldVal.BmapPoint){
                    //记录坐标已改变状态
                    this.change = true;
                }
            },
            deep: true
        },
    },
    activated(){
      var screenHeight = document.documentElement.clientHeight;  

      var titleHeight = 0 ;
      
    if( this.$route.query.sourceflag != 'app'  )
      document.getElementsByClassName("pageTitle")[0].offsetHeight

      console.log(titleHeight)
      this.mapHeight = screenHeight - titleHeight;
      //如果坐标改变了
      if(this.change == true){
        //初始化状态
        this.initState()
        //先定位中心点
        //重新加载地图
        var point = new BMap.Point(this.g_currentInfo.BmapPoint.split(",")[1],this.g_currentInfo.BmapPoint.split(",")[0]); // 创建点坐标
        var marker = new BMap.Marker(point,{icon:this.myIcon});  // 创建标注  
        this.map.centerAndZoom(point,15);
        //移除所有覆盖物
        this.map.clearOverlays()
        //移除上一个导航记录
        this.driving.clearResults()
        this.map.enableScrollWheelZoom();
        this.map.addOverlay(marker);
      }
    }
}
</script>











// WEBPACK FOOTER //
// mapbook.vue?2f0cb559